import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-comment-list',
  templateUrl: './comment-list.component.html',
  styleUrls: ['./comment-list.component.scss'],
})
export class CommentListComponent implements OnInit {
  @Input() set reviews(value: any[]){
    if(value){
      this.fixedReviews = value.slice(0,5);
      this.restReviews = value.slice(5, value.length);
    }
  };
  // public stars = [1,1,1,1,1];
  public fixedReviews = [];
  public restReviews = [];
  public image = '/assets/img/logo/logo-naranja-light.png';
  public seeAll = false;
  public url = environment.url;

  constructor() { }

  ngOnInit() {}

  allReviews(){
    if(this.seeAll){
      this.fixedReviews = this.fixedReviews.slice(0,5);
    }else{
      this.fixedReviews.push(...this.restReviews);
    }
    this.seeAll = !this.seeAll;
  }
}
